import React from 'react';
import { TagManagementPage } from './TagManagementPage';
import { useTags, useCreateTag, useUpdateTag, useDeleteTag } from '../../hooks/useTags';
import { Alert, Button, CircularProgress, Box } from '@mui/joy';

/**
 * Container component that connects TagManagementPage to data hooks
 */
export const TagManagementPageContainer: React.FC = () => {
  const { data: tags = [], isLoading, error, refetch } = useTags(false);
  const createTagMutation = useCreateTag();
  const updateTagMutation = useUpdateTag();
  const deleteTagMutation = useDeleteTag();

  const handleCreateTag = async (name: string, color: string) => {
    await createTagMutation.mutateAsync({ name, color });
  };

  const handleUpdateTag = async (id: number, name: string, color: string) => {
    await updateTagMutation.mutateAsync({ id, name, color });
  };

  const handleDeleteTag = async (id: number) => {
    await deleteTagMutation.mutateAsync(id);
  };

  if (error) return <Alert color="danger" endDecorator={<Button onClick={() => refetch()}>Retry</Button>}>Could not load tags.</Alert>;

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '400px',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <TagManagementPage
      tags={tags}
      onCreateTag={handleCreateTag}
      onUpdateTag={handleUpdateTag}
      onDeleteTag={handleDeleteTag}
    />
  );
};

export default TagManagementPageContainer;
